import Image from 'next/image';
import logo from '@/public/assets/icons/Logo/Logo.svg';
import styles from './RedirectHome.module.scss';
export function RedirectHome() {

  return (
    <figure className={styles.redirectHome}>
      <Image src={logo} alt="logo" style={{ width: '58%', height: '100%' }} />
    </figure>
  );
}
